import * as React from 'react'
import { ReactElement } from 'react'
import { makeStyles, shorthands, Text, tokens } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'

export const useDocumentToastStyles = makeStyles({
    toaster: {
        display: 'grid',
        ...shorthands.gap(tokens.spacingHorizontalM, tokens.spacingVerticalS),
    },
    moreInfo: {
        display: 'grid',
        gridTemplateColumns: 'min-content 1fr',
        ...shorthands.gap(tokens.spacingHorizontalM, tokens.spacingVerticalXS),
        alignItems: 'baseline',
    },
    details: {
        ...shorthands.overflow('auto'),
        maxHeight: '10em',
    },
    button: {
        display: 'flex',
        justifyContent: 'end',
    },
})

export default function ReleaseMessageToastContent(): ReactElement {
    const styles = useDocumentToastStyles()
    const { t: translate } = useTranslation()

    return (
        <div className={styles.toaster}>
            <Text size={500} weight={'bold'}>
                {translate('base.warning.release_window.title')}
            </Text>
            <Text>{translate('base.warning.release_window.description')}</Text>
        </div>
    )
}
